import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

const Home = lazy(() => import("./home/HomeThree"));
const About = lazy(() => import("./pages/About"));
// const Services = lazy(() => import("./service/Services"));
const ServiceDetailsLeftSidebar = lazy(() =>
  import("./service/ServiceDetailsLeftSidebar")
);
const ServiceArea = lazy(() => import("./home/ServicePage"));
const Project1 = lazy(() => import("./project/Project1"));
const Projects = lazy(() => import("./project/Projects"));
const ProjectDetails = lazy(() => import("./project/ProjectDetails"));
const BlogDetailsRightSidebar = lazy(() =>
  import("./blog/BlogDetailsRightSidebar")
);
const Contact = lazy(() => import("./pages/Contact"));
const NoMAtch = lazy(() => import("./pages/404"));

const App = () => {
  return (
    <Router>
      <Suspense fallback={<div />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about-us" element={<About />} />
          <Route path="/services" element={<ServiceDetailsLeftSidebar />} />
          <Route path="/testimonials" element={<ServiceArea />} />
          <Route path="/sidingGallery" element={<Project1 />} />
          <Route path="/gallery" element={<Projects />} />
          <Route path="/project-details" element={<ProjectDetails />} />
          <Route
            path="/blog-details-right-sidebar"
            element={<BlogDetailsRightSidebar />}
          />
          <Route path="/contact-us" element={<Contact />} />
          <Route path="*" element={<NoMAtch />} />
        </Routes>
      </Suspense>
    </Router>
  );
};

export default App;
